const AccessProfileTypeNPS = {
  1: 'Analyst',
  2: 'Master Data Solutions',
  3: 'Supplier Profile',
  4: 'Scheduler',
  5: 'Manager',
  6: 'Administrator',
};

export default AccessProfileTypeNPS;